import React from "react";
import S from './Program.module.scss';

interface ProgramProps {
    event?: any;
}

export const ProgramPanelOne = ({event}: ProgramProps) => {
    return (
        <div className={S.panelStyle}>
            <div className={S.titlePanelDiv}>
                <div className={event === 5 ? S.paragraphLogistics : S.paragraph}/>
                <div className={S.hallPanel}>ЭКСКУРСИЯ</div>
                <div className={S.paragraphPanel}>
                    <div className={event === 5 ? S.titlePanelLogistics : S.titlePanel}>
                        <span>ПРОМЫШЛЕННЫЙ ТУР НА ЧЕРЕПОВЕЦКИЙ МЕТАЛЛУРГИЧЕСКИЙ КОМБИНАТ.</span>
                    </div>
                    <div className={S.paragraphDiv}>
                        <div className={S.paragraphTextTitleExcursion}>ЭКСКУРСИОННАЯ ПРОГРАММА:</div>
                        <div className={S.paragraphTextDiv}>
                            <div className={S.trait}/>
                            <div className={S.paragraphText}>ПОСЕЩЕНИЕ ЦЕНТРА МЕТАЛЛУРГИЧЕСКОЙ ПРОМЫШЛЕННОСТИ</div>
                        </div>
                        <div className={S.paragraphTextDiv}>
                            <div className={S.trait}/>
                            <div className={S.paragraphText}>СМОТРОВАЯ ГАЛЕРЕЯ ДОМЕННОЙ ПЕЧИ №5 «СЕВЕРЯНКА» И<br/>
                                САМОГО ПРОИЗВОДИТЕЛЬНОГО В РОССИЙСКОЙ МЕТАЛЛУРГИИ СТАНА 2000
                            </div>
                        </div>
                    </div>
                    <div className={S.descriptionExcursionText}>
                        Доменная печь №5 «Северянка» на момент пуска и далее на протяжении почти 20 лет оставалась самой
                        большой печью в
                        мире. Высота агрегата – 105 метров, а полный объем составляет более 5,5 тысяч кубометров. В силу
                        масштабов домна-гигант
                        была занесена даже в книгу рекордов Гиннесса. Ее текущая производительность – 4,2 миллиона тонн
                        чугуна в год. В 2023 году
                        печь выпустила 35% чугуна ЧерМК. Остекленная смотровая галерея, оснащенная интерактивными
                        элементами, размещена на
                        высоте 14 метров над литейным двором ДП-5.
                    </div>
                    <div className={event === 5 ? S.titlePanelLogistics : S.titlePanel} style={{ paddingTop: '20px' }}>
                        ВАЖНО: <span>РЕГИСТРАЦИЯ НА ЭКСКУРСИЮ ОБЯЗАТЕЛЬНА.</span> ПРЕДПРИЯТИЕ ЯВЛЯЕТСЯ РЕЖИМНЫМ ОБЪКТОМ.
                    </div>
                </div>
            </div>
        </div>
    );
};